// fb-185: shared store for the Data Health ACTIVE-warning count, so the left-menu item and the top (☰) menu item
// can both show a badge. Fetched once per session (admin pages only), refreshed on demand (the Data Health page
// publishes the live count after a refresh/accept). Tiny pub/sub, same pattern as benchmarkIssues.js.
import { useState, useEffect } from 'react';
import { shellRead } from './shellRead';   // Round 4e: one shell request, after paint

let _count = null;
let _started = false;
const _subs = new Set();

export function setDataHealthCount(n) {
  const v = Number(n);
  if (!Number.isFinite(v) || v === _count) return;
  _count = v;
  _subs.forEach((fn) => fn(v));
}

export function useDataHealthCount(enabled = true) {
  const [n, setN] = useState(_count);
  useEffect(() => {
    if (!enabled) return undefined;
    _subs.add(setN); setN(_count);
    if (!_started) { _started = true; shellRead('data_health').then(r => setDataHealthCount(r && r.count)).catch(() => { _started = false; }); }
    return () => { _subs.delete(setN); };
  }, [enabled]);
  return n;
}
